var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav2'),_c('banner2',{attrs:{"bannerH":_vm.bannerH,"bannerP":_vm.bannerP,"bannerImg":require('@/assets/img/product/banner.jpg')}}),_c('div',{staticClass:"content-container"},[_c('router-view')],1),_c('footer2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }